import React from "react"

import { TeamRole } from "entities/team-members/types/TeamRole"

import { DefaultTeamLeaveOverlayView } from "./ui/DefaultTeamLeaveOverlayView"

export interface DefaultTeamLeaveOverlayProps {
  role: TeamRole | null | undefined
  isLastAdmin: boolean
  isLastTeamMember: boolean
  isUpdatingAdmin?: boolean
  wasLastAdmin?: boolean
  onSubmit: () => void
  onCancel: () => void
}

export const DefaultTeamLeaveOverlay = React.memo(
  (props: DefaultTeamLeaveOverlayProps) => (
    <DefaultTeamLeaveOverlayView {...props} />
  )
)
